import { useEffect, useState } from "react";
import { Box, Button, Paper, alpha } from "@mui/material";
import { styled } from "@mui/material/styles";
import Navbar from "../../components/navbar";
import StepOne from "../../components/Counselling/InitialInfo/StepOne";
import StepTwo from "../../components/Counselling/InitialInfo/StepTwo";
import StepThree from "../../components/Counselling/InitialInfo/StepThree";
import StepFour from "../../components/Counselling/InitialInfo/StepFour";
import apiClient from "../../utils/apiClient";
import { useNavigate } from "react-router-dom";

// --------------------
// Styled components (unchanged)
// --------------------
const DashboardWrapper = styled(Box)(({ theme }) => ({
  position: "relative",
  minHeight: "100vh",
  backgroundColor: "#f8fafc",
  overflow: "hidden",
  "&::before": {
    content: '""',
    position: "absolute",
    width: "100%",
    height: "100%",
    left: 0,
    top: 0,
    backgroundImage: `url("/image 7.png")`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "100% 100%",
    backgroundPosition: "center",
    backgroundColor: "#f8fafc",
    opacity: 1,
    zIndex: 0,
    pointerEvents: "none",
  },
}));
const ContentContainer = styled(Box)(({ theme }) => ({
  position: "relative",
  maxWidth: "1200px",
  margin: "0 auto",
  padding: theme.spacing(3),
  [theme.breakpoints.down("sm")]: { padding: theme.spacing(2) },
  zIndex: 1,
}));

// --------------------
// MAIN COMPONENT
// --------------------
const AreaTypeInfo = () => {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const handleNext = (data) => {
    setFormData((prev) => ({ ...prev, ...data }));
    setStep((prev) => prev + 1);
  };

  const handleBack = () => {
    navigate("/basic-info");
  };

  // const [hasBoughtCounselling, setHasBoughtCounselling] = useState(false);
  const [checkingStatus, setCheckingStatus] = useState(true);

  useEffect(() => {
    const checkBuyStatus = async () => {
      try {
        const response = await apiClient.get("/counselling/buyStatus");
        console.log(response);
        if (response?.data?.success) {
          if (response.data.boughtStatus == false) {
            navigate("/counselling-checkout");
          }
        }
      } catch (error) {
        console.error("Failed to check counselling buy status:", error);
      } finally {
        setCheckingStatus(false);
      }
    };

    checkBuyStatus();
  }, []);

  // ✅ SIDE EFFECT — API CALL
  useEffect(() => {
    if (step !== 2 || isSubmitting) return;

    const saveCounsellingData = async () => {
      try {
        setIsSubmitting(true);

        console.log("Submitting counselling data:", formData);

        const response = await apiClient.patch(
          "/counselling/initial-info/area-type",
          {
            areaType: formData.areaType || "Random",
          },
        );

        console.log("✅ Counselling data saved:", response.data);

        // OPTIONAL: redirect or move ahead
        const res = await apiClient.get("/counselling/initial-info/category");
        if (res.data.success) {
          const category = res.data.data.category;
          if (["Class 10th", "Class 11th", "Class 12th"].includes(category)) {
            navigate("/workshop-info");
          } else {
            navigate("/past-info");
          }
        } else {
          alert("Some error occurred!");
        }
      } catch (error) {
        console.error(
          "❌ Error saving counselling data:",
          error?.response?.data || error.message,
        );
      } finally {
        setIsSubmitting(false);
      }
    };

    saveCounsellingData();
  }, [step]);

  // ✅ PURE RENDER FUNCTION
  const renderStep = () => {
    switch (step) {
      case 1:
        return <StepTwo onNext={handleNext} onBack={handleBack} />;
      // case 2:
      //   return <StepTwo onNext={handleNext} onBack={handleBack} />;
      // case 3:
      //   return <StepThree onNext={handleNext} onBack={handleBack} />;
      // case 4:
      //   return <StepFour onNext={handleNext} onBack={handleBack} />;
      case 2:
        return (
          <Box textAlign="center" mt={6}>
            <h2>Saving your details...</h2>
          </Box>
        );
      default:
        return null;
    }
  };

  return (
    <DashboardWrapper>
      <Navbar />
      <ContentContainer>{renderStep()}</ContentContainer>
    </DashboardWrapper>
  );
};

export default AreaTypeInfo;
